import { IGResponse } from '@common/models';
import { IAgenda } from '@common/models/CMS/Agenda';
import Title from '@components/general/Title';
import { AGENDA, useApolloQuery } from '@service/graphql';
import Translate from '@service/Translate';
import { FC, useMemo } from 'react';
import AgendaItem from './AgendaItem';

const AgendaViewer: FC = () => {
    const { tr } = Translate;
    const { data } = useApolloQuery<IGResponse<IAgenda[]>>(AGENDA, { variables: { first: 10, skip: 0 } });

    const groupingData = useMemo(() => {
        const nowDate = new Date().getTime();
        const upcomingData = data?.agenda?.filter(agenda => new Date(agenda.endTime || 0).getTime() >= nowDate);
        const latestsDate = data?.agenda?.filter(agenda => new Date(agenda.endTime || 0).getTime() < nowDate);
        return { upcomingData, latestsDate }
    }, [data]);

    const cards = (dataSource: IAgenda[]) =>
        <article className="cards flex row">
            {dataSource?.map((data, index) =>
                <div key={`agenda_card_item_${index}`} className="agenda-card-container col-1-4 col-sm-1-1">
                    <AgendaItem data={data} />
                </div>
            )}
        </article>

    return (
        <main className="agenda-viewer container">
            {groupingData?.upcomingData?.length &&
                <section className="group-container upcoming">
                    <Title className="group-header" text={tr("upcomming_events")} size="h2" />
                    {cards(groupingData.upcomingData)}
                </section>
            }
            {groupingData?.latestsDate?.length &&
                <section className="group-container">
                    <Title className="group-header" text={tr("latest_agenda")} size="h2" />
                    {cards(groupingData.latestsDate)}
                </section>
            }
        </main>
    );
}

export default AgendaViewer
